const isStaging = () => document.location.hostname.indexOf('staging') !== -1;

export default isStaging;
